import {
  getCarrotUserId,
  getEmployeeId,
  getFirstName,
  getGenderIdentity,
  getInterest,
  getJourney,
  getPartnerGenderIdentity,
  getPartnerSex,
  getSex
} from "reducers/userInfo"
import { getParentCompanyOrCompanyName, getCompanyName, getParentCompanyName } from "reducers/companyInfo"
import { getHasDeductible } from "derivedSelectors/deductibleSelectors"
import { Middleware } from "redux"
import { DefaultRootState } from "react-redux"
import { getHeap } from "../utils/heap"

const valuesToWatch: Record<string, (state: DefaultRootState) => any> = {
  "Employee first name": getFirstName,
  "Parent Company or Company Name": getParentCompanyOrCompanyName,
  "Company Name": getCompanyName,
  "Parent Company Name": getParentCompanyName,
  Journey: getJourney,
  Interest: getInterest,
  "Gender Identity": getGenderIdentity,
  Sex: getSex,
  "Employee Id": getEmployeeId,
  "Partner Sex": getPartnerSex,
  "Partner Gender Identity": getPartnerGenderIdentity,
  "CarrotUser Id": getCarrotUserId,
  "Has Deductible": getHasDeductible
}

const heapMiddleware: Middleware = (store) => (next) => (action) => {
  const previousState = store.getState()
  const result = next(action)
  const nextState = store.getState()
  const modifiedValues: Record<string, any> = {}

  const heapKeysToWatch = Object.keys(valuesToWatch)
  for (const valueToWatchKey of heapKeysToWatch) {
    const selector = valuesToWatch[valueToWatchKey]
    const previousValue = selector(previousState)
    const nextValue = selector(nextState)

    if (previousValue !== nextValue && nextValue !== null) {
      modifiedValues[valueToWatchKey] = nextValue
    }
  }

  const haveValuesChanged = Object.keys(modifiedValues).length > 0

  if (haveValuesChanged) {
    addHeapProperties(modifiedValues)
  }

  return result
}

const addHeapProperties = (modifiedValues: Record<string, any>) => {
  const carrotUserId = modifiedValues["CarrotUser Id"]
  if (carrotUserId !== null) {
    getHeap().identify(carrotUserId)
  }
  getHeap().addUserProperties(modifiedValues)

  if (process.env.NODE_ENV !== "production") {
    console.group("Heap properties added")
    console.log("Values", modifiedValues)
    console.groupEnd()
  }
}

export { heapMiddleware }
